import * as THREE from 'three'
import { Path } from 'src/constants/parameters'

type Axis = 'x' | 'y'

export const reverseVectorPath = (path: THREE.Path) => {
  const points = path.getPoints()
  return new THREE.Path(points.reverse())
}

export const rotateVectorPath = (path: THREE.Path, rotation: 90 | 180 | 270): THREE.Path =>
  new THREE.Path(
    path.getPoints().map(({ x, y }) => {
      const next = rotation === 90 ? [y, x] : rotation === 180 ? [-x, -y] : [-y, -x]
      return new THREE.Vector2(...next)
    })
  )

export const mirrorVectorPath = (path: THREE.Path, axis: Axis) =>
  new THREE.Path(path.getPoints().map(({ x, y }) => new THREE.Vector2(...(axis === 'x' ? [x, -y] : [-x, y]))))

export const stickPaths = (paths: (THREE.Path | THREE.Vector2)[]): THREE.Path =>
  paths.reduce<THREE.Path>((p, curr, i) => {
    if (i === 0 && curr instanceof THREE.Vector2) return new THREE.Path([curr])
    const points = p.getPoints()
    const lastPoint = points.length > 0 ? points[points.length - 1] : p.currentPoint
    if (curr instanceof THREE.Path) {
      const nextPoints = curr.getPoints()
      const translatedNext = lastPoint ? nextPoints.map(v => v?.add(lastPoint)) : nextPoints
      p.setFromPoints(translatedNext)
    } else if (curr instanceof THREE.Vector2) {
      p.lineTo(lastPoint.x + curr.x, lastPoint.y + curr.y)
    }
    return p
  }, new THREE.Path())

export const v = (path: Path): THREE.Path => new THREE.Path(path.map(([x, y]) => new THREE.Vector2(x, y)))
